"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Map = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Map = () => {
    return (react_1.default.createElement(react_native_1.View, { style: styles.container },
        react_1.default.createElement(react_native_1.Text, { style: styles.text }, "\u041C\u0435\u0441\u0442\u043E \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F:"),
        react_1.default.createElement(react_native_1.Text, { style: styles.textSecond }, "\u0428\u0430\u0442\u0451\u0440 \u0412\u043E\u043B\u0436\u0441\u043A\u0438\u0439, \u043D\u0430\u0431. \u0413\u0440\u0435\u0431\u043D\u043E\u0433\u043E \u043A\u0430\u043D\u0430\u043B\u0430, 109 \u04411"),
        react_1.default.createElement("iframe", { src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d657.630850947708!2d44.05336466415076!3d56.32986976350307!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x41502b3621eaca73%3A0xa46391ebd1378751!2z0K_RhdGCLdC60LvRg9CxICLQm9C10YLQviI!5e0!3m2!1sen!2sru!4v1649519097182!5m2!1sen!2sru", loading: "lazy", referrerPolicy: "no-referrer-when-downgrade" })));
};
exports.Map = Map;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        padding: 10,
        margin: 10,
        alignItems: 'center',
    },
    text: {
        color: 'white',
        fontSize: 20,
        fontWeight: 'bold',
        textAlign: 'center',
        fontStyle: 'italic',
    },
    textSecond: {
        color: 'white',
        fontSize: 15,
        textAlign: 'center',
        fontStyle: 'italic',
    },
});
